import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { useHistory } from "react-router-dom";
import "./style.scss";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import Pagination from "react-js-pagination";
import { Button as MaterialButton } from "@material-ui/core";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import profile from "../../../../../assets/svg/dashboard/profile-iconRound.svg";
import excelButton from "../../../../../assets/images/maargThemeXls2.png";
import {
  getStartupApplication,
  getCountersStartUpList,
} from "../dependencies/action";
import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import Modal from "../MyRequests/Modal/modal";
import Select from "react-select";
import Button from "../../AdminDashboard/Button";
import {
  getNamesList,
  destructNamesList,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { DOWNLOAD_EXCEL_STARTUP_REQUEST } from "../../../../common/constants/ApplicationUrl";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const StartUpApplication = (props) => {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const html = document.getElementsByTagName("html")[0];
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const { getNamesList, getNamesListData, destructNamesList } = props;
  const [activeText, setActiveText] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");

  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [indexCounter, setIndexCounter] = useState(0);
  const [nameListValue, setNameListValue] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [filterNameValue, setFilterNameValue] = useState("");

  const defaultFormData = {
    search: "",
    industry: null,
    specialization: null,
    stage: null,
    recognized: "",
    state: "",
    country: "",
  };
  const indDefaultObject2 = {
    value: "select",
    label: "Select State",
  };

  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [formData, setFormData] = useState(defaultFormData);
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [newCountrySelect, setNewCountrySelect] = useState(false);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [filterState, setFilterState] = useState("");
  const [filterCountry, setFilterCountry] = useState("");
  const [isShown, setIsShown] = useState(false);
  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };

  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getStepperTooltipData,
    getStepperData,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  useEffect(() => {
    html.style.overflow = "auto";

    localStorage.setItem("startUpApplications", "startUpApplications");
    setTimeout(() => {
      localStorage.removeItem("allMentorList");
      localStorage.removeItem("allMentorsMentorship");
      localStorage.removeItem("allStartupList");
      localStorage.removeItem("allMentorships");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("mentorMenu");
      localStorage.removeItem("startupMentorAllMentorships");
      localStorage.removeItem("StartupSubmittedApplications");
      localStorage.removeItem("cohortApplication");
      localStorage.removeItem("mentorRequests");
    }, 1000);
    if (props?.location?.state?.requestStatus === undefined || props.location?.state?.requestStatus === "viewAll" ) {
      setActiveText(true);
      renderTable("");
    } else if (props?.location?.state?.requestStatus === "pending") {
      setActiveText2(true);
      renderTable("PENDING")
    }else {setActiveText(true);renderTable("")}
  }, []);
  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    if (getNamesListData !== undefined && getNamesList !== null)
      getNamesListData?.forEach((element, index) => {
        if (index === 0) {
          let arr2 = {
            value: "Select",
            label: "Select StartUp",
          };
          setNameListValue((oldArray) => [...oldArray, arr2]);
        }
        let arr = {
          value: element.id,
          label: element.name,
        };
        if (getNamesListData.length >= nameListValue.length)
          setNameListValue((oldArray) => [...oldArray, arr]);
      });
  }, [getNamesListData]);
  const getStartupApplicationTable = (status) => {
    setActivePage(1);
    let params = {
      requestedBy: "",
      status: status,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      searchKey: null,
      country: "",
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupApplication(params);
  };
  const getStartUpListDataNameSearch = (name) => {
    let params = {
      requestedBy: "",
      status: "",
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: name === "Select" ? "" : name,
      searchKey: null,
      status: selectedStatus,
      country: "",
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupApplication(params);
  };
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
    newStateArray.unshift(indDefaultObject2);
  }, []);
  const renderTable = (status)=>{
    let params = {
      requestedBy: "",
      status: status,
      pageFilter: {
        currentPage: 0,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: null,
      searchKey: null,
      country: "",
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupApplication(params);
  }
  // useEffect(() => {
  //   let params = {
  //     requestedBy: "",
  //     status: "",
  //     pageFilter: {
  //       currentPage: 0,
  //       pageSize: 10,
  //       sortField: "id",
  //       sortOrder: "ASC",
  //     },
  //     searchField: null,
  //     searchKey: null,
  //     country: "",
  //     state: formData.state == "select" ? null : formData?.state?.label, // optional
  //     industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
  //     function: formData.function == "select" ? "" : formData?.function?.value, // optional
  //     stage: formData.stage == "select" ? "" : formData?.stage?.value,
  //   };
  //   getStartupApplication(params);
  // }, []);

  const customStyles = {
    option: (provided, state) => ({
      ...provided,

      textAlign: "left",
    }),
    menu: (base) => ({
      ...base,
      width: "max-content",
      minWidth: "100%",
      fontSize: "14px",
    }),
  };
  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);

  useEffect(() => {
    if (
      history?.location?.state?.requestStatus === "viewAll" ||
      history?.location?.state?.requestStatus === undefined
    ) {
      getStartupApplicationTable("");
    } else {
      getStartupApplicationTable("PENDING");
    }
  }, []);
  const ViewApplication = (item) => {
    let reRoute = window.open(`/view-StartupApplication/${item}`, "_blank");
    reRoute.id = item;
    reRoute.fromModule = "startUpApplications";
  };
  const redirectProfile = (item) => {
    let reRoute = window.open(`/startup-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      requestedBy: "",
      status: selectedStatus,
      pageFilter: {
        currentPage: pageNumber - 1,
        pageSize: 10,
        sortField: "id",
        sortOrder: "ASC",
      },
      searchField: filterNameValue == "Select" ? "" : filterNameValue,
      searchKey: null,
      country: "",
      // id: formData?.name?.value == "select" ? null : formData?.name?.value, // optional
      state: formData.state == "select" ? null : formData?.state?.label, // optional
      industry: formData.industry == "select" ? "" : formData?.industry?.value, // optional
      function: formData.function == "select" ? "" : formData?.function?.value, // optional
      stage: formData.stage == "select" ? "" : formData?.stage?.value,
    };
    getStartupApplication(params);
  };
  useEffect(() => {
    let params = {
      requestedBy: "",
    };
    getCountersStartUpList(params);
  }, []);
  useEffect(() => {
    setTableList(startUpApplication);
    let data = startUpApplication?.requestJson;
    setMentorShipReqData(data);
  }, [startUpApplication]);
  const getStartUpId = (string) => {
    const value = string.substring(string?.length - 6);
    return value;
  };

  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };

  useEffect(() => {
    window.scrollTo(0, 1);
  }, []);
  useEffect(() => {
    return () => {
      destructNamesList();
    };
  }, []);
  return (
    <>
      <div className="mentorlistmaindiv2 startupapplication-mobileview3">
        <div
          className="dashboard-main2 admndashstrtupapplidiv"
          style={{ background: "none" }}
        >
          <div
            className="dashboard-bottom-btn4 topbackbtnmentorlist"
            style={{ background: "transparent", border: "none" }}
          >
            <div className="newuserTooltip">
              <MaterialButton
                className="topbackbtnactual top-btn"
                variant="contained"
                color="primary"
                onClick={() => {
                  localStorage.setItem(
                    "mentorDashboardHome",
                    "mentorDashboardHome"
                  );
                  localStorage.removeItem("startUpApplications");
                  window.location.reload();
                }}
                style={{ background: "#3ac2d7" }}
              >
                {" "}
                Back
              </MaterialButton>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  top: "69px",
                  width: "200px",
                  left: "71px",
                }}
              >
                Click to Go My Dashboard
              </span>
            </div>
            <Modal
              modalOpen={modalOpen}
              setModalOpen={setModalOpen}
              modalData={modalData}
            />
          </div>
          <div className="iconWith-heading strtupappliadmindashappwith ">
            <div style={{ width: "100%" }} className="mainhead">
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow reqiiueststartup">
                ADMIN DASHBOARD: STARTUP REQUESTS
              </h3>
            </div>
            <div className="bothiconadjustment">
              <a href={DOWNLOAD_EXCEL_STARTUP_REQUEST}>
                <div className="newuserTooltip">
                  <img
                    className="excelButton excelbuttonadmindash23"
                    src={excelButton}
                    // style={{ top: "2rem", width: "47%", left: "3rem" }}
                  ></img>
                  <span
                    className="tooltiptext tooltip-bottom applustar"
                    style={{
                      left: "-46px",
                      top: "2px",
                      width: "143px",
                      height: "46px",
                    }}
                  >
                    Download Excel Report
                  </span>
                </div>
              </a>
              <div
                className="tooltipshow eyeIcon iconitop"
                // onClick={() => {
                //   // html.style.overflow = "hidden";

                //   if (html.style.overflow == "auto") {
                //     html.style.overflow = "hidden";
                //   } else {
                //     html.style.overflow = "auto";
                //   }
                // }}
              >
                <div className="newuserTooltip">
                  <img
                    className="iconbtn top-btn"
                    src={iconTooltip}
                    onClick={() => {
                      setModalIsOpenToTrue();
                      if (html.style.overflow == "auto") {
                        html.style.overflow = "hidden";
                      } else {
                        html.style.overflow = "auto";
                      }
                    }}
                    width={60}
                  />{" "}
                  <span
                    className="tooltiptext tooltip-bottom "
                    style={{ width: "130px", top: "50px", left: "20px" }}
                  >
                    View Instructions
                  </span>
                </div>
              </div>
              {isShown && (
                <div>
                  <AnimeList
                    setModalIsOpenToTrue={setModalIsOpenToTrue}
                    Heading={Heading}
                    InstructionswithRole={InstructionswithRole}
                    SelectPage={SelectPage}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow">
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 mentorAppButton">
              <div className="dashboard-bottom-btn2">
                <p className="text-white2"> REQUEST STATUS</p>
              </div>
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(true);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  getStartupApplicationTable("");
                }}
                style={{
                  color: activeText ? "#277acc" : "#838186",
                  left:'-0.5rem'
                }}
                className="admindasheaderoptions applicationHeading  demorequest"
              >
                MENTORSHIP <br></br> REQUIREMENT  :{" "}
                {getCounterStartUp && getCounterStartUp.totalSearch !== null
                  ? getCounterStartUp.totalSearch
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "25px", width: "270px" }}
              >
                Click to View Mentorship Requirement
              </span>
              {activeText ? (
                <img
                  className="requestStatusBar"
                  src={LineWithDot}
                  style={{
                    minWidth: "150px",
                    position: "relative",
                    right: "14px",
                  }}
                />
              ) : (
                ""
              )}
            </div>
           
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 newuserTooltip">
              <p
                onClick={() => {
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(true);
                  getStartupApplicationTable("REQUESTED");
                  setSelectedStatus("REQUESTED");
                }}
                style={{
                  color: activeText5 ? "#277acc" : "#838186",
                  left:'-0.5rem'
                }}
                className="admindasheaderoptions applicationHeading  demorequest"
              >
                MENTOR REQUEST <br></br> SENT  :{" "}
                {getCounterStartUp && getCounterStartUp.total !== null
                  ? getCounterStartUp.total
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "25px", width: "270px" }}
              >
                Click to View Mentor Requests Sent
              </span>
              {activeText5 ? (
                <img
                  className="requestStatusBar"
                  src={LineWithDot}
                  style={{
                    minWidth: "150px",
                    position: "relative",
                    right: "14px",
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div
              className="col-xs-6 col-sm-6 col-md-2 col-lg-1 newuserTooltip"
              style={{ position: "relative", left: "-4rem" }}
            >
              <p
                onClick={() => {
                  setActiveText2(true);
                  setActiveText(false);
                  setActiveText3(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  setSelectedStatus("PENDING");
                  getStartupApplicationTable("PENDING");
                }}
                style={{ color: activeText2 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading2"
              >
                {" "}
                PENDING <br></br>RESPONSE :{" "}
                {getCounterStartUp && getCounterStartUp.pending !== null
                  ? getCounterStartUp.pending
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "75px", width: "260px" }}
              >
                Click to View Pending Response
              </span>
              {activeText2 ? (
                <img
                  className="requestStatusBar positionBar"
                  src={LineWithDot}
                  style={{
                    minWidth: "150px",
                    position: "relative",
                    left: "0.6rem",
                  }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-1 startUpDashBox newuserTooltip acceptedhdrstrtupappli"
            style={{left:"-2.5rem"}}>
              <p
                onClick={() => {
                  setActiveText3(true);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(false);
                  setActiveText5(false);
                  getStartupApplicationTable("ACCEPTED");
                  setSelectedStatus("ACCEPTED");
                }}
                style={{ color: activeText3 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions applicationHeading3"
              >
                {" "}
                ACCEPTED :{" "}
                {getCounterStartUp && getCounterStartUp.accepted !== null
                  ? getCounterStartUp.accepted
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "68px", width: "254px" }}
              >
                Click to View Accepted Applications
              </span>
              {activeText3 ? (
                <img
                style={{left: "2.35rem",
                  width: "156px"}}
                  className="requestStatusBar positionBar2"
                  src={LineWithDot}
                />
              ) : (
                ""
              )}
            </div>
            <div className="col-xs-6 col-sm-6 col-md-2 col-lg-2 startUpDashBox newuserTooltip acceptedhdrstrtupappli">
              <p
                onClick={() => {
                  setActiveText3(false);
                  setActiveText(false);
                  setActiveText2(false);
                  setActiveText4(true);
                  setActiveText5(false);
                  getStartupApplicationTable("REJECTED");
                  setSelectedStatus("REJECTED");
                }}
                style={{ color: activeText4 ? "#277acc" : "#838186" }}
                className="admindasheaderoptions"
              >
                {" "}
                DECLINED :{" "}
                {getCounterStartUp && getCounterStartUp.rejected !== null
                  ? getCounterStartUp.rejected
                  : 0}
              </p>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{ left: "19px", width: "244px" }}
              >
                Click to View Declined Applications
              </span>
              {activeText4 ? (
                <img
                  className="requestStatusBar"
                  src={LineWithDot}
                  style={{
                    width: "133px",
                    position: "relative",
                    left: "1.5rem",
                  }}
                />
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="filter-row filter-row-common filterDivMentorapp">
            <div>
              <form className="formContainer newfilterdivnow">
                <div className="row desktopFilterRow">
                  <div className="col-11 d-flex justify-content-between filter-bigDiv">
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="searchBy"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="searchBy"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.name}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              name: e.name == "select" ? null : e,
                            };
                          });
                          setFilterName(e.name);
                          setFilterNameValue(e.value);
                          getStartUpListDataNameSearch(e.value);
                        }}
                        options={nameListValue.length > 0 ? nameListValue : ""}
                        placeholder="Search StartUp"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Startup
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="Industry"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="industry"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.industry}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              industry: e.value == "select" ? null : e,
                            };
                          });
                          setFilterIndustry(e.value);
                        }}
                        options={getPredefineOptions?.industry_options}
                        placeholder="Industry"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Industry
                      </span>
                    </div>
                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="specialization"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="specialization"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.function}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              function: e.value == "select" ? null : e,
                            };
                          });
                          setFilterFunction(e.value);
                        }}
                        options={getPredefineOptions?._specialisation}
                        placeholder="Function"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Function
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip allstartuplistforsame">
                      <Select
                        required={true}
                        id="stage"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="stage"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.stage}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              stage: e.value == "select" ? null : e,
                            };
                          });
                          setFilterStage(e.value);
                        }}
                        options={getPredefineOptions?.stage_of_startup_options}
                        placeholder="Stage"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search Stage
                      </span>
                    </div>

                    <div className="user-type-dropdown adminfilterdropdown dropDownWidthFix2 newuserTooltip ">
                      <Select
                        required={true}
                        id="state"
                        variant="outlined"
                        fullWidth
                        margin="normal"
                        name="state"
                        className="col-12 gendermentorinput"
                        styles={customStyles}
                        value={formData.state}
                        onChange={(e) => {
                          setFormData((user) => {
                            return {
                              ...user,
                              state: e.value == "select" ? null : e,
                            };
                          });
                          setFilterState(e.value);
                        }}
                        options={newStateOptions}
                        placeholder="State"
                      />
                      <span
                        className="tooltiptext tooltip-bottom"
                        style={{ left: "77px", top: "45px", width: "130px" }}
                      >
                        Search State
                      </span>
                    </div>
                  </div>

                  <div className="apply-section d-flex justify-content-end col-1 newuserTooltip">
                    <Button
                      onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="GO"
                      className="filter-button top-btn newcoloredbtn startupColorBtn"
                    ></Button>
                    <span
                      className="tooltiptext   tooltip-bottom"
                      style={{
                        left: "46px",
                        width: "126px",
                        height: "48px",
                        top: "42px",
                      }}
                    >
                      Click to Apply Filters
                    </span>
                  </div>
                </div>

                <div className="row mobileFilterRow">
                  <div className="col-md-1 filter-text">Filter by</div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="searchBy"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="searchBy"
                      className="col-12 gendermentorinput input1admndashstrtupappli"
                      styles={customStyles}
                      value={formData.name}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            name: e.name == "select" ? null : e,
                          };
                        });
                        setFilterName(e.name);
                        setFilterNameValue(e.value);
                        getStartUpListDataNameSearch(e.value);
                      }}
                      options={nameListValue.length > 0 ? nameListValue : ""}
                      placeholder="Search StartUp"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="Industry"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="industry"
                      className="col-12 gendermentorinput input1admndashstrtupappli"
                      styles={customStyles}
                      value={formData.industry}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            industry: e.value == "select" ? null : e,
                          };
                        });
                        setFilterIndustry(e.value);
                      }}
                      options={getPredefineOptions?.industry_options}
                      placeholder="Industry"
                    />
                  </div>
                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="specialization"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="specialization"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.function}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            function: e.value == "select" ? null : e,
                          };
                        });
                        setFilterFunction(e.value);
                      }}
                      options={getPredefineOptions?._specialisation}
                      placeholder="Function"
                    />
                  </div>

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="stage"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="stage"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.stage}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            stage: e.value == "select" ? null : e,
                          };
                        });
                        setFilterStage(e.value);
                      }}
                      options={getPredefineOptions?.stage_of_startup_options}
                      placeholder="Stage"
                    />
                  </div>
                  {/* <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="country"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="country"
                      className="col-12 gendermentorinput"
                      styles={customStyles}
                      value={formData.country}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            country: e.value == "select" ? null : e,
                          };
                        });

                        setFilterCountry(e.label);

                        if (e.label === "India") {
                          setNewCountrySelect(true);
                        } else {
                          setNewCountrySelect(false);
                        }
                        setNewStateOptions("");
                      }}
                      options={newCountryOptions}
                      placeholder="Country"
                    />
                  </div> */}

                  <div className="user-type-dropdown col-2 select-box">
                    <Select
                      required={true}
                      id="state"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      name="state"
                      className="col-12 gendermentorinput input1admndashstrtupappli"
                      styles={customStyles}
                      value={formData.state}
                      onChange={(e) => {
                        setFormData((user) => {
                          return {
                            ...user,
                            state: e.value == "select" ? null : e,
                          };
                        });
                        setFilterState(e.value);
                      }}
                      options={newStateOptions}
                      placeholder="State"
                    />
                  </div>
                  <div
                    className="col-md-1 apply-section"
                    style={{ color: "transparent" }}
                  >
                    <Button
                      className="green-btn filter-btn"
                      onClick={() => getStartupApplicationTable(selectedStatus)}
                      text="Go"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>

          <div className="totalTableCount">
            Total Startups Found: {startUpApplicationPagineate?.totalElements}{" "}
            &lt;
            {startUpApplicationPagineate?.currentPage} of{" "}
            {startUpApplicationPagineate?.numPages} &gt;{" "}
          </div>
          {startUpApplication && startUpApplication?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th className="tableJustify fixColumbnWidth111">
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th className="fixColumbnWidth112" colspan="2">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          STARTUP
                        </div>
                      </th>

                      <th
                        className="fixColumbnWidth113"
                        style={{ whitespace: "nowrap", fontSize: "15.3px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          MENTORSHIP REQUIREMENT ID
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth114"
                        style={{ whitespace: "nowrap", fontSize: "15.3px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          APPLICATION DATE
                        </div>
                      </th>
                      <th className="fixColumbnWidth115">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          REQUEST SENT TO MENTOR
                        </div>
                      </th>
                      <th className="fixColumbnWidth116">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          PURPOSE OF REQUEST
                        </div>
                      </th>
                      <th className="fixColumbnWidth117">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            height: "60px",
                          }}
                        >
                          MENTOR REQUEST STATUS
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {startUpApplication &&
                      startUpApplicationPagineate &&
                      startUpApplication.map((item, index) => (
                        <tr
                          key={index}
                          className={
                            item.requestId === indexCounter
                              ? "purpleBackground"
                              : ""
                          }
                        >
                          {startUpApplicationPagineate?.currentPage === 1 ? (
                            <td style={{ verticalAlign: "top" }}>
                              <div className="strtupappliindex">
                                {index + 1}
                              </div>
                            </td>
                          ) : (
                            <td style={{ verticalAlign: "top" }}>
                              <div>
                                {index +
                                  1 +
                                  10 *
                                    (startUpApplicationPagineate?.currentPage -
                                      1)}
                              </div>
                            </td>
                          )}
                          <td
                            className="strtupapplinametd"
                            style={{
                              justifyContent: "center",
                            }}
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={
                                  item.startupImage === null
                                    ? hashImage
                                    : item.startupImage
                                }
                                onClick={() => {
                                  setIndexCounter(item.requestId);
                                  redirectProfile(item.dpiitNo);
                                }}
                                className="sidebar-dashboard-icon2"
                                style={{
                                  width: "100%",
                                  cursor: "pointer",
                                  height: "100%",
                                  objectFit: "contain",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "88px",
                                  width: "150px",
                                }}
                              >
                                View Startup Profile
                              </span>
                              <p className="strtupapplimobilename">
                                {/* {item.startupName} */}
                                {item?.startupName?.length > 20 ? (
                                  <div className="tooltipicon">
                                    {item.startupName.substring(0, 20)}
                                    <svg
                                      style={{
                                        position: "relative",
                                        top: "0.1rem",
                                        cursor: "pointer",
                                      }}
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="20"
                                      height="20"
                                      fill="currentColor"
                                      class="bi bi-three-dots"
                                      viewBox="0 0 16 16"
                                    >
                                      <path d="M3 9.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3z" />
                                    </svg>
                                    <span className="tooltiptext7">
                                      <h5 style={{ color: "#fff" }}>
                                        Program Name
                                      </h5>
                                      {item.startupName}
                                    </span>
                                  </div>
                                ) : (
                                  item.startupName
                                )}
                              </p>
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setIndexCounter(item.requestId);
                                  ViewApplication(item.dpiitNo);
                                }}
                                className="color-green strtupapplimobilelink"
                              >
                                {item.dpiitNo}
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "46px",
                                    top: "40px",
                                    width: "180px",
                                  }}
                                >
                                  View Startup Application
                                </span>
                              </a>
                            </div>
                          </td>
                          <td
                            className="matchList-tooltip strtupappliadmndashmobile"
                            style={{
                              verticalAlign: "top",
                              position: "relative",
                            }}
                          >
                            <div
                              style={{
                                flexDirection: "row",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                style={{
                                  alignItems: "center",
                                  display: "flex",
                                  maxWidth: "240px",
                                  minWidth: "240px",
                                }}
                              >
                                <div>
                                  {item.startupName}
                                  <div className="newuserTooltip">
                                    <a
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setIndexCounter(item.requestId);
                                        ViewApplication(item.dpiitNo);
                                      }}
                                      className="color-green "
                                    >
                                      <p>{item.dpiitNo}</p>
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={{
                                          left: "46px",
                                          top: "40px",
                                          width: "180px",
                                        }}
                                      >
                                        View Startup Application
                                      </span>
                                    </a>
                                  </div>
                                </div>
                              </div>{" "}
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  position: "absolute",
                                  right: "0px",
                                  bottom: "0px",
                                  padding: "12px",
                                }}
                                onClick={() => {
                                  setIndexCounter(item.requestId);
                                  redirectProfile(item.dpiitNo);
                                }}
                              >
                                <img src={profile} height={40} width={40} />

                                <span
                                  className="tooltiptext tooltip-bottom "
                                  style={{
                                    left: "46px",
                                    top: "61px",
                                    width: "150px",
                                  }}
                                >
                                  View Startup Profile
                                </span>
                              </div>
                            </div>
                          </td>

                          <td
                            className="matchList-tooltip newmenreqstrtupappli"
                            style={{ verticalAlign: "top" }}
                          >
                            <div
                              className="belowdivnewmenreqstrtupappli"
                              style={{
                                display: "flex",
                                paddingLeft:"10px",
                                // justifyContent: "center",
                                alignItems: "center",
                              }}
                            >
                              <div>
                                <div className="newuserTooltip">
                                  <a
                                    onClick={() => {
                                      setIndexCounter(item?.requestId);
                                      setModalData(item?.requestJson);
                                      setModalOpen(true);
                                    }}
                                    className="color-green "
                                  >
                                    S{getStartUpId(item?.requestId)}
                                    <span
                                      className="tooltiptext-require tooltip-bottomx"
                                      style={{ top: "30px", left: "-40px" }}
                                    >
                                      View Mentorship Requirement
                                    </span>
                                  </a>
                                </div>
                                {item?.mentorRequests &&
                                item?.mentorRequests?.length > 0 &&
                                item?.mentorRequests[0].match === true ? (
                                  <div></div>
                                ) : (
                                  <div className="newuserTooltip">
                                    <a
                                      onClick={() => {
                                        setIndexCounter(item.requestId);
                                        props.setMentorMatchlistId(
                                          item?.requestId
                                        );
                                        window.open(
                                          `/startup-dashboard/match-list/${item?.requestId}`,
                                          "_blank"
                                        );
                                        let reRoute = window;
                                        reRoute.fromModule = "AdminModule";
                                      }}
                                      className="color-green"
                                    >
                                      View Match Table
                                    </a>
                                    <span
                                      className="tooltiptext tooltip-bottom"
                                      style={{ left: "55px" }}
                                    >
                                      View Match Table
                                    </span>
                                  </div>
                                )}
                              </div>
                            </div>
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            <div className="belowdivapplidatestrtupappli">
                              {moment(item.applicationDate).format(
                                "DD/MM/YYYY"
                              )}
                              <br />

                              {moment(item.applicationDate).format("hh:mm A")}
                            </div>
                          </td>

                          <td className="matchList-tooltip p-0 menreqsentmaintd">
                            <div className="borderstrtupmaindiv">
                              {item.mentorRequests !== undefined &&
                                Object.keys(item.mentorRequests).map(function (
                                  key,
                                  index
                                ) {
                                  return (
                                    <>
                                      <div
                                        className={
                                          index ===
                                          item.mentorRequests.length - 1
                                            ? "borderStartUp2"
                                            : "borderStartUp"
                                        }
                                      >
                                        <div>
                                          {" "}
                                          {
                                            item.mentorRequests[key].mentorName
                                          }{" "}
                                          <p style={{ fontSize: "15px" }}>
                                            {moment(
                                              item.mentorRequests[key]
                                                .requestToMentorDate
                                            ).format("DD/MM/YYYY")}
                                          </p>
                                        </div>
                                        <div
                                          className="d-flex justify-content-end newuserTooltip"
                                          style={{
                                            cursor: "pointer",
                                            alignItems: "end",
                                            justifyContent: "end",
                                            display: "flex",
                                          }}
                                        >
                                          <img
                                            src={profile}
                                            onClick={() =>
                                              ViewProfile(
                                                item.mentorRequests[key]
                                                  .mentorEmail,
                                                item.mentorRequests[key].id
                                              )
                                            }
                                            style={{
                                              width: "40px",
                                              position: "relative",
                                              top: "0.7rem",
                                              right: "0.4rem",
                                              paddingBottom: "1rem",
                                            }}
                                            className="reqsentimgicon"
                                          />
                                          <span
                                            className="tooltiptext tooltip-bottom"
                                            style={{
                                              left: "101px",
                                              top: "57px",
                                              width: "150px",
                                            }}
                                          >
                                            View Mentor Profile
                                          </span>
                                        </div>
                                      </div>
                                    </>
                                  );
                                })}
                            </div>
                            {item.mentorRequests !== undefined &&
                              Object.keys(item.mentorRequests).map(function (
                                key,
                                index
                              ) {
                                return (
                                  <>
                                    <div
                                      className={
                                        index === item.mentorRequests.length - 1
                                          ? "borderStartUp2 borderstrtupdeskmaindiv"
                                          : "borderStartUp borderstrtupdeskmaindiv"
                                      }
                                    >
                                      <div>
                                        {" "}
                                        {
                                          item.mentorRequests[key].mentorName
                                        }{" "}
                                        <p style={{ fontSize: "15px" }}>
                                          {moment(
                                            item.mentorRequests[key]
                                              .requestToMentorDate
                                          ).format("DD/MM/YYYY")}
                                        </p>
                                      </div>
                                      <div
                                        className="d-flex justify-content-end newuserTooltip"
                                        style={{
                                          cursor: "pointer",
                                          alignItems: "end",
                                          justifyContent: "end",
                                          display: "flex",
                                        }}
                                      >
                                        <img
                                          src={profile}
                                          onClick={() =>
                                            ViewProfile(
                                              item.mentorRequests[key]
                                                .mentorEmail,
                                              item.mentorRequests[key].id
                                            )
                                          }
                                          style={{
                                            width: "40px",
                                            position: "relative",
                                            top: "0.7rem",
                                            right: "0.4rem",
                                            paddingBottom: "1rem",
                                          }}
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={{
                                            left: "101px",
                                            top: "57px",
                                            width: "150px",
                                          }}
                                        >
                                          View Mentor Profile
                                        </span>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </td>

                          <td
                            className="m-0 p-0 menreqsentmaintd purrequestdivtd"
                            style={{ verticalAlign: "top" }}
                          >
                            {item.mentorRequests !== undefined &&
                              Object.keys(item.mentorRequests).map(function (
                                key,
                                index
                              ) {
                                return (
                                  <>
                                    {item?.mentorRequests[key]
                                      ?.purposeOfMentorship?.length > 54 ? (
                                      <>
                                        <div
                                          className={
                                            index ===
                                            item.mentorRequests.length - 1
                                              ? "borderStartUp2 m-0 p-0 "
                                              : "borderStartUp m-0 p-0 "
                                          }
                                        >
                                          <div
                                            className="tooltipicon startuprequest-dummy"
                                            style={{ cursor: "pointer" }}
                                          >
                                            {item?.mentorRequests[
                                              key
                                            ]?.purposeOfMentorship?.slice(
                                              0,
                                              40
                                            )}{" "}
                                            {item?.mentorRequests[key]
                                              ?.purposeOfMentorship?.length >
                                              40 && <b>...</b>}
                                            <span className="tooltiptext8">
                                              <h5
                                                style={{
                                                  fontWeight: 600,
                                                  color: "#fff",
                                                }}
                                              >
                                                Purpose of Request
                                              </h5>
                                              {
                                                item?.mentorRequests[key]
                                                  ?.purposeOfMentorship
                                              }
                                            </span>
                                          </div>
                                        </div>
                                      </>
                                    ) : (
                                      <>
                                        <td
                                          style={{ verticalAlign: "top" }}
                                          className={
                                            index ===
                                            item.mentorRequests.length - 1
                                              ? "borderStartUp2 m-0 p-0 showpurofreqdiv"
                                              : "borderStartUp m-0 p-0 showpurofreqdiv"
                                          }
                                        >
                                          {
                                            item.mentorRequests[key]
                                              .purposeOfMentorship
                                          }
                                        </td>
                                        <p className="showpurofreqdivmobile">
                                          {" "}
                                          {
                                            item.mentorRequests[key]
                                              .purposeOfMentorship
                                          }
                                        </p>
                                      </>
                                    )}
                                  </>
                                );
                              })}
                          </td>
                          <td
                            className="m-0 p-0 menreqsentmaintd menreqstatusdivtd"
                            style={{ verticalAlign: "top" }}
                          >
                            {item.mentorRequests !== undefined &&
                              Object.keys(item.mentorRequests).map(function (
                                key,
                                index
                              ) {
                                return (
                                  <>
                                    <div
                                      className={
                                        index === item.mentorRequests.length - 1
                                          ? "borderStartUp2"
                                          : "borderStartUp"
                                      }
                                    >
                                      {" "}
                                      {item?.mentorRequests[key].requestStatus}
                                    </div>
                                  </>
                                );
                              })}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {(startUpApplication !== undefined &&
                    startUpApplication.length) > 0 ? (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={
                        startUpApplicationPagineate?.totalElements
                      }
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
          <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip"
            style={{ margin: "auto" }}
            onClick={() => {
              history.push({
                state: {
                  fromModule: "startUpApplications",
                },
              });
              localStorage.setItem("allStartupList", "allStartupList");
              window.location.reload();
            }}
          >
            <p
              style={{ cursor: "pointer" }}
              className="text-white3 startuprequestStartup"
            >
              VIEW STARTUP LIST
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "410px", top: "60px", width: "200px" }}
            >
              Click to View Startup List
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
  };
};
export default connect(mapStateToProps, {
  getStartupApplication,
  getCountersStartUpList,
  getPredefineOptionsList,
  getStepperTooltipData,
  getNamesList,
  destructNamesList,
})(withRouter(StartUpApplication));